<script setup>
import MainMenu from "../components/MainMenu.vue";
import Header from "../components/Header.vue";
</script>

<template>
  <div class="flex min-h-screen max-h-screen h-screen overflow-hidden">
    <!-- Боковая панель -->
    <aside class="py-2 pl-2 md:py-4 md:pl-4 max-h-full overflow-auto">
      <MainMenu />
    </aside>

    <!-- Основной контент -->
    <div class="flex-1 flex flex-col max-h-full overflow-hidden bg-white">
      <!-- Header -->
      <Header class="flex-shrink-0" />

      <div class="flex-1 flex flex-col p-2 pt-1 md:p-4 md:pt-2 min-h-0">

      <slot />
      </div>
    </div>
  </div>
</template>

